import { useContext } from 'react';
import { StoreContext } from '@/utils/providers/StoreProvider';

export const useStores = () => {
    return useContext(StoreContext);
};
